import { ScreenContainerTwoPotato } from "components/ScreenContainerPotato";
import { ImageList, ImageListItem } from "@mui/material";
import Typography from "@mui/joy/Typography";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Tooltip from "@mui/joy/Tooltip";
import Stack from "@mui/joy/Stack";

import Chip from "@mui/joy/Chip";
import Next from './PotatoNext';
import { getIcon } from "utils/misc";




export default function PotatoWhatDoYouGet({ onInView }: { onInView: (visibile: boolean, id: string) => boolean }) {
    const ProjectIcon = getIcon('DayOnesProject');
    const StarIcon = getIcon('Star');
    const StorefrontIcon = getIcon('Storefront');
    const AdaptingIcon = getIcon('Insights');
    const DayOnesIcon = getIcon('WbTwilight');
    const LocalPostOfficeIcon = getIcon('LocalPostOffice');

    const TermsIcon = (
        <Tooltip arrow title="Dedicated Plans only">
            <StarIcon fontSize={'xs'} color="warning" />
        </Tooltip>
    );
    return (
<ScreenContainerTwoPotato
                    view="what-do-you-get"
                    onInView={onInView}
                    reversed={true}
                    window={<ImageList

                        variant="woven"
                        cols={1}
                        gap={1}>
                        <ImageListItem key="lawnmower" >
                            <img src="/handmade/lawnmower.webp"
                                alt="A selection of screenshots from our app throughout time. The images are on top of an image of the office." />
                        </ImageListItem>
                        <ImageListItem key="gooey-wood" >
                            <img src="/handmade/gooey-wood.webp"
                                alt="A selection of screenshots from our app throughout time. The images are on top of an image of the office." />
                        </ImageListItem>
                        <ImageListItem key="gooey-wood" >
                            <img src="/handmade/snow.webp"
                                alt="A selection of screenshots from our app throughout time. The images are on top of an image of the office." />
                        </ImageListItem>
                        <ImageListItem key="koozie-closeup" >
                            <img src="/merch/koozie-closeup.webp"
                                alt="A selection of screenshots from our app throughout time. The images are on top of an image of the office." />
                        </ImageListItem>
                    </ImageList>


                    }>

                    <Typography >
                        You get Fancy Hands
                    </Typography>
                    <Typography level="title-lg">
                        What do you get?
                    </Typography>
                    <Typography level="body-md">
                         Dedicated plans include:
                    </Typography>


                    <List>
                        <ListItem>
                            <ListItemDecorator><ProjectIcon /></ListItemDecorator>
                            <ListItemContent

                            ><Typography endDecorator={TermsIcon}>Unlimited Projects</Typography></ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><StarIcon color="success" /></ListItemDecorator>
                            <ListItemContent><Typography endDecorator={TermsIcon}>Unlimited Collabs</Typography></ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><StorefrontIcon /></ListItemDecorator>
                            <ListItemContent> <Tooltip arrow title="We'll send you merch (physical merch) in the mail. Just ask!"><Chip endDecorator={<LocalPostOfficeIcon />}>Merch Care Package</Chip></Tooltip> </ListItemContent>
                        </ListItem>

                        <ListItem>
                            <ListItemDecorator><AdaptingIcon color="success" /></ListItemDecorator>
                            <ListItemContent>Access to Day Ones</ListItemContent>
                        </ListItem>
                        {/*

                        <ListItem>
                            <ListItemDecorator><FiguringItOutIcon color="primary" /></ListItemDecorator>
                            <ListItemContent>We're still here figuring it all out</ListItemContent>
                        </ListItem>
                          */}
                        <ListItem>
                            <ListItemDecorator><DayOnesIcon color="danger" /></ListItemDecorator>
                            <ListItemContent>The Fancy Hands Team</ListItemContent>
                        </ListItem>
                    </List>

                    <Stack sx={{
                        position: "absolute",
                        padding: 1,
                        bottom: 3,
                        left: 3
                    }} >
                        <Tooltip
                            arrow
                            title="The standard fine print applies.">
                            <Typography
                                level="body-sm"
                                sx={{ cursor: "pointer" }}
                            >
                               <StarIcon fontSize={'xs'} color="warning" /> Dedicated Plans.  Billed by the minute. Unlimited within reason. Subject to change. While supplies last. US shipping only.
                            </Typography>
                        </Tooltip>
                    </Stack>
                    <Next
                        nextId="about-fancyhands"
                        ks="Who made this?" />

                        </ScreenContainerTwoPotato>
);
}
